import useScrollAnimation from '../../hooks/useScrollAnimation';

interface TrustItem {
  value: string;
  label: string;
  icon: string;
}

interface TrustBarProps {
  items?: TrustItem[];
}

const defaultItems: TrustItem[] = [
  { value: 'Est. 2003', label: 'Over 20 Years of Certified Expertise', icon: 'ri-award-fill' },
  { value: '5 States', label: 'MN · IA · WI · ND · SD', icon: 'ri-map-2-fill' },
  { value: 'Res + Com', label: 'Residential & Commercial Projects', icon: 'ri-building-2-fill' },
  { value: 'Free', label: 'On-Site Consultations & Estimates', icon: 'ri-hand-coin-fill' },
];

const TrustBar = ({ items = defaultItems }: TrustBarProps) => {
  const { ref, isVisible } = useScrollAnimation();
  return (
    <section
      ref={ref}
      className={`anim-section ${isVisible ? 'is-visible' : ''} relative z-20 -mt-20 px-4 lg:px-10`}
    >
      <div className="max-w-screen-xl mx-auto">
        <div className="bg-[#0d0b07] border border-[#c8a951]/20" style={{ borderTop: '2px solid #c8a951' }}>
          {/* Top gold rule + label */}
          <div className="px-8 pt-5 pb-0 flex items-center gap-3">
            <div className="w-6 h-px bg-[#c8a951]/60" />
            <p className="text-[#c8a951] text-[9px] uppercase tracking-[0.5em] font-semibold">Polished Concrete Plus — At a Glance</p>
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-4 divide-x divide-[#c8a951]/12">
            {items.map((item, i) => (
              <div
                key={i}
                className="flex flex-col items-center text-center py-7 px-6"
              >
                <div className="w-9 h-9 flex items-center justify-center mb-3">
                  <i className={`${item.icon} text-lg text-[#c8a951]`} />
                </div>
                <span
                  className="text-2xl font-bold text-white mb-1"
                  style={{ fontFamily: '"Playfair Display", serif' }}
                >
                  {item.value}
                </span>
                <span className="text-[10px] text-white/40 uppercase tracking-[0.14em] leading-snug max-w-[120px]">
                  {item.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
